var _class, _MobileSearch;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { addMarker } from "../../Models/LocationMarkerUtils";
import LocationSearchResults from "../Search/LocationSearchResults";
import SearchResult from "../Search/SearchResult";
import { withTranslation } from "react-i18next";
import Styles from "./mobile-search.scss";

// A Location item when doing Bing map searvh or Gazetter search
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let MobileSearch = observer(_class = (_MobileSearch = class MobileSearch extends Component {
  onLocationClick(result) {
    runInAction(() => {
      result.clickAction();
      addMarker(this.props.terria, result);

      // Close modal window
      this.props.viewState.switchMobileView(null);
      this.props.viewState.searchState.showMobileLocationSearch = false;
    });
  }
  searchInDataCatalog() {
    const {
      searchState
    } = this.props.viewState;
    runInAction(() => {
      // Set text here so that it doesn't get batched up and the catalog
      // search text has a chance to set isWaitingToStartCatalogSearch
      searchState.catalogSearchText = searchState.locationSearchText;
    });
    this.props.viewState.searchInCatalog(searchState.locationSearchText);
  }
  render() {
    const theme = "light";
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.mobileSearch,
      children: [/*#__PURE__*/_jsx("div", {
        children: this.renderSearchInCatalogLink(theme)
      }), /*#__PURE__*/_jsx("div", {
        className: Styles.location,
        children: this.renderLocationResult(theme)
      })]
    });
  }
  renderSearchInCatalogLink(theme) {
    const {
      t
    } = this.props;
    const searchState = this.props.viewState.searchState;
    if (searchState.locationSearchText.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: Styles.providerResult,
      children: /*#__PURE__*/_jsx("ul", {
        className: Styles.btnList,
        children: searchState.catalogSearchProvider && /*#__PURE__*/_jsx(SearchResult, {
          clickAction: () => this.searchInDataCatalog(),
          icon: null,
          locationSearchText: searchState.locationSearchText,
          name: t("search.search", {
            searchText: searchState.locationSearchText
          }),
          searchResultTheme: theme
        })
      })
    });
  }
  renderLocationResult(theme) {
    const searchState = this.props.viewState.searchState;
    return searchState.locationSearchResults.map(search => /*#__PURE__*/_jsx(LocationSearchResults, {
      terria: this.props.terria,
      viewState: this.props.viewState,
      search: search,
      locationSearchText: searchState.locationSearchText,
      onLocationClick: this.onLocationClick.bind(this),
      isWaitingForSearchToStart: searchState.isWaitingToStartLocationSearch,
      theme: theme
    }, search.searchProvider.name));
  }
}, _defineProperty(_MobileSearch, "propTypes", {
  viewState: PropTypes.object,
  terria: PropTypes.object,
  t: PropTypes.func.isRequired
}), _MobileSearch)) || _class;
export default withTranslation()(MobileSearch);